import axiosClient from "axiosClient";
import axiosClientDistribution from "axiosClient/indexDistribution";
import axiosClientHyperWolf from "axiosClient/indexHyperWolf";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchBrandsAPI(filters={}) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/brand?${getQueryString(filters)}`);
}
export async function fetchBrandsStoreAPI(filters = {}) {
    return await axiosClientStilo.get(`/api/v1/brand?${getQueryString(filters)}`);
}
export async function deletBrandAPI(brandId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/brand/${brandId}`);
}

export async function createBrandAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/brand`, data);
}

export async function fetchBrandDetailsAPI(brandId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/brand/${brandId}?userType=admin`);
}

export async function updateBrandAPI(data,brandId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/brand/update/${brandId}`, data);
}

export function getMainBrandsAPI() {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).get('api/v1/brand/main/page');
}

export function updateMainBrandAPI(data) {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`api/v1/brand/update/main/metas`, data);
}

export async function fetchBrandsPlatformAPI(filters={}) {
    if(filters?.platform === 'stilo'){
        return await axiosClientStilo.get(`/api/v1/brand?${getQueryString(filters)}`);
    }
    if(filters?.platform === 'hyperwolf'){
       return await  axiosClientHyperWolf.get(`/api/v1/partner/store/inventory/brands`)
    }   

     if(filters?.platform === 'hemp'){
        return await axiosClient.get(`/api/v1/brand?${getQueryString(filters)}`);
    }  
}